import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';

export default class ListEntryDTO extends DataTransferObject {

    public DisplayName: string;

    public SelectionValue: object;

    constructor() {
        super({ xmlProperties: ['DisplayName', 'SelectionValue'] });

        this.DisplayName = this.defaultFromType('string');
        this.SelectionValue = this.defaultFromType('object');
    }
}

ComponentManager.setModel('ListEntryDTO', ListEntryDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');